/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as sis from './SISApp'
import { componentApi, loadTranslations } from 'common'


export class StudentSelectApi {
  async GetCurrentClass(stuGU : string, ssyGU : string) : Promise<sis.ICurrentClassInfo> {
    return await componentApi.call('sis', 'sis-student-select', 'StudentSelectApi', 'GetCurrentClass', {
      stuGU,
      ssyGU,
    });
  }
  async Find(viewState : sis.ViewState, search : string) : Promise<Array<sis.StudentRecord>> {
    return await componentApi.call('sis', 'sis-student-select', 'StudentSelectApi', 'Find', {
      viewState,
      search,
    });
  }
  async GetUserHistory() : Promise<sis.StudentEntityHistory> {
    return await componentApi.call('sis', 'sis-student-select', 'StudentSelectApi', 'GetUserHistory', {
    });
  }
}
export default new StudentSelectApi()
